import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button, Dropdown, Grid } from 'semantic-ui-react';
import MyTextInput from '../../app/common/form/MyTextInput';
import { useStore } from '../../app/stores/store';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { GetSingleUserById } from '../../app/models/user';
import { v4 as uuid } from 'uuid';

export default observer(function RegisterForm() {
  const history = useNavigate();
  const { userStore, RolesAndPermissionsStore, commonStore } = useStore();
  const { rolesByName } = RolesAndPermissionsStore;
  const { register } = userStore;
  const initialState = {
    id: '',
    displayName: '',
    password: '',
    newpassword: '',
    email: '',
    username: '',
    fullName: '',
    customerName: '',
    departmentName: '',
    addressLine1: '',
    addressLine2: '',
    country: '',
    state: '',
    city: '',
    postalCode: '',
    phoneNumber: '',
    alternatePhoneNumber: '',
    remarks: '',
    role: '',
    workPosition: '',
    superior: '',
    website: '',
    workDepartment: '',
    workApplicationsKnown: '',
    languagesKnown: '',
    photos: [],
    image: '',
    roleId: '',
    isAdmin: false,
    roleName: '',
  };
  const [departmentdata, setdepartmentdata] =
    useState<GetSingleUserById>(initialState);

  const roleOptions = rolesByName.map((x) => ({
    key: x.id,
    text: x.roleName,
    value: x.roleName,
  }));

  const handleFormSubmit = (values: GetSingleUserById) => {
    if (values.id === '') {
      const newDepartmentData = {
        ...values,
        id: uuid(),
      };
      register(newDepartmentData, () => history('/dashboard'));
      setdepartmentdata(initialState);
    }
  };
  return (
    <Formik
      initialValues={departmentdata}
      enableReinitialize={true}
      onSubmit={(values) => handleFormSubmit(values)}
      validationSchema={Yup.object({
        displayName: Yup.string().required(),
        username: Yup.string().required(),
        email: Yup.string().required().email(),
        password: Yup.string().required(),
      })}
    >
      {({ handleSubmit, isSubmitting, isValid, dirty }) => (
        <>
          <h1 style={{ color: 'black' }}>Create User</h1>
          <Form
            className="ui form error"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Grid container columns={2}>
              <Grid.Column>
                <MyTextInput
                  name="displayName"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="username"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="email"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="password"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                  type="password"
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="customerName"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="departmentName"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="address"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="addressLine"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="phoneNumber"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <MyTextInput
                  name="alternatePhoneNumber"
                  placeholder={
                    (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  style={{ width: '92%' }}
                  placeholder="Roles"
                  selection
                  options={roleOptions}
                />
                <Button
                  as={Link}
                  to="/roles"
                  style={{
                    borderRadius: '30px',
                    marginTop: '5px',
                    marginLeft: '8px',
                  }}
                  icon="settings"
                  positive
                  size="mini"
                  disabled={
                    (userLanguage[0].UserCreateUser?.UCUB01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                      ? false
                      : true
                  }
                />
              </Grid.Column>
            </Grid>
            <Button
              style={{ marginTop: '10px' }}
              disabled={!isValid || !dirty || isSubmitting}
              loading={isSubmitting}
              positive
              content={
                (userLanguage[0].UserCreateUser?.UCUB02 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              type="submit"
              fluid
            />
          </Form>
        </>
      )}
    </Formik>
  );
});
